const CompaniesAdapter = data => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const prepareData = (i) => ({
    ...i,
    mall_title: i.shopping_center?.title,
    chain: i.chain?.title,
  });

  if (Array.isArray(data)) {
    data.forEach(i => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};

export default CompaniesAdapter;